// extracted by mini-css-extract-plugin
export var background = "_96-6";
export var containerMedium = "_96-0";
export var containerMicro = "_96-2";
export var containerSmall = "_96-1";
export var dropdown = "_96-5";
export var dropdownLabel = "_96-a";
export var enter = "_96-7";
export var exitActive = "_96-8";
export var label = "_96-3";
export var option = "_96-9";
export var select = "_96-4";